import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { NDCHighLevelRoadmapPage } from 'src/app/model/page/ndc-high-level-roadmap-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-ndc-high-level-roadmap-page',
  templateUrl: './ndc-high-level-roadmap-page.component.html',
  styleUrls: ['./ndc-high-level-roadmap-page.component.scss']
})
export class NDCHighLevelRoadmapPageComponent implements OnInit {
  ndcHighLevelRoadmapPage: NDCHighLevelRoadmapPage = {} as NDCHighLevelRoadmapPage;
  quarterKeyValueMap = new Map();
  constructor(private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'high-level-roadmap') {
        this.ndcHighLevelRoadmapPage.htmlTitle = title.htmlTitle;
      }
    });
    this.ndcHighLevelRoadmapPage.sections = [];
    this.ndcHighLevelRoadmapPage.ndcHighLevelRoadmapSections = [];
    const query = { 'fields.title': 'NDC High level Roadmap' };
    this.contentfulService.getPageContentResponse(query).then((ndcHighLevelRoadmapPageEntries) => {
      this.mapBanners(ndcHighLevelRoadmapPageEntries.includes.Entry);
      this.mapPageInfo(ndcHighLevelRoadmapPageEntries.items);
      this.mapSections(ndcHighLevelRoadmapPageEntries.includes.Entry);
    });
  }

  private mapBanners(ndcHighLevelRoadmapPageEntries: Entry<any>[]) {
    ndcHighLevelRoadmapPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    this.ndcHighLevelRoadmapPage.banner = {
      title:  entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url,
    };
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.ndcHighLevelRoadmapPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.ndcHighLevelRoadmapPage.banner.url = entry.fields?.url;
      this.ndcHighLevelRoadmapPage.banner.editorEmail = editorDetails?.pop();
      this.ndcHighLevelRoadmapPage.banner.editorShortName = editorDetails?.pop();
      this.ndcHighLevelRoadmapPage.banner.editorFullName = editorDetails?.pop();
      this.ndcHighLevelRoadmapPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapSections(ndcHighLevelRoadmapPageEntries: Entry<any>[]) {
    ndcHighLevelRoadmapPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        switch (entry.fields['position']) {
          case 'MIDDLE':
            this.mapEntryToSection(entry);
            break;
          default:
            this.mapEntryToLeftRightSection(entry);
        }
      });
    this.ndcHighLevelRoadmapPage.ndcHighLevelRoadmapSections.sort((a, b) => b.order - a.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();
    this.ndcHighLevelRoadmapPage.sections.push({
      title: pageTitle,
      body:  entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order:  entry.fields['order'] as number
    });
  }

  private mapEntryToLeftRightSection(entry: Entry<any>) {
    let title:any = entry.fields['title'] as string;
    // console.log(entry);
    this.ndcHighLevelRoadmapPage.ndcHighLevelRoadmapSections.push({
      title: title.split('#').pop(),
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      position: entry.fields['position'] as string,
      category: entry.fields['category'] as string,
      heading: entry.fields['heading'] as string,
      sectionClass: entry.fields['sectionClass'] as string,
      subBody: entry.fields['subBody'] as string,
      roadmapYear: entry.fields['roadmapYear'] as string
    });
  }
}
